export default __webpack_public_path__ + "1520dec5f140a006267062252f808be5.jpg";